export const bookingPaths = [
  '/flights',
  '/extra',
  '/seats',
  '/checkout',
  '/confirmation',
  '/mmb/summary',
  '/mmb/contact',
  '/mmb/infant',
  '/wci/flight',
  '/wci/passenger',
  '/disruption',
]

export const searchPaths = [
  '/search',
]

export function isBookingPath(pathname: string): boolean {
  if(!pathname) return false;
  return bookingPaths.some((path) => pathname.includes(path));
}

export function isSearchPath(pathname: string): boolean {
  if(!pathname) return false;
  return searchPaths.some((path) => pathname.includes(path));
}


export const multiBookingWarning = "It looks like booking {0} is already open in another tab or window. " +
                                   "Please continue managing your booking there. " +
                                   "Any changes made in this window will not be saved, and you may encounter errors if you continue here.";
